<template>
  <div class="login-container">
    <v-card class="login-card" elevation="6" rounded="lg">

      <!-- Alert zprava -->
      <v-alert
          v-model="showLogoutMessage"
          color="warning"
          variant="tonal"
          icon="mdi-alert-circle"
          closable
          class="mb-4"
      >
        Z bezpecnostnich duvodu jste byl odhlasen. Muzete se znovu prihlasit.
      </v-alert>

      <!-- Header sekce -->
      <div class="text-center mb-6">
        <img src="@/assets/ben.png" alt="Logo" class="logo-image mb-4">

        <h2 class="text-h5 font-weight-regular mb-1">
         Přihlášení do formuláře
        </h2>

        <h1 class="text-h4 font-weight-bold primary--text mb-1">
          FPSZČ
        </h1>

        <p class="text-body-2 text-medium-emphasis">
          Fondu podpory sportu a zájmové činnosti        </p>
      </div>

      <v-divider class="mx-4 mb-6"></v-divider>

      <!-- Tlacitko Google -->
      <v-card-text class="pt-2">
        <v-row justify="center">
          <v-col cols="12" sm="10" md="8">
            <v-btn
                :loading="isLoading"
                block
                color="primary"
                variant="elevated"
                @click="handleSignInGoogle"
                class="login-btn"
                rounded
            >
              <span class="btn-text">Prihlasit se pomoci Google</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text class="text-center text-body-2 text-medium-emphasis pt-4">
        Bezpecne prihlaseni pres Google ucet
      </v-card-text>
    </v-card>
  </div>
</template>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 16px;
}

.login-card {
  max-width: 500px;
  width: 100%;
  padding: 36px 24px;
  border-radius: 18px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.1) !important;
}

.logo-image {
  width: 160px;
  height: 160px;
  object-fit: contain;
  margin: 0 auto;
}

.btn-text {
  font-size: 16px;
  font-weight: 500;
  white-space: nowrap;
}

.login-btn {
  font-weight: 500;
  letter-spacing: 0.5px;
  transition: transform 0.2s ease-in-out;
  min-height: 50px;
}

.login-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

@media (max-width: 600px) {
  .login-card {
    padding: 24px 16px;
  }
  .btn-text {
    font-size: 14px;
  }
}

@media (max-width: 380px) {
  .btn-text {
    font-size: 13px;
  }
}
</style>

<script>
import firebaseApp from "@/firebase";
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import axios from "axios";
import { baseURL } from "@/Baseurl";

firebaseApp;

export default {
  name: "LoginView",

  data() {
    return {
      user: JSON.parse(localStorage.getItem('user')),
      isSignedIn: !!localStorage.getItem('user'),
      userUid: localStorage.getItem('user_uid'),
      isAdmin: localStorage.getItem('is_admin'),
      isLoading: false,
      showLogoutMessage: false,
    };
  },

  mounted() {
    const message = localStorage.getItem('logoutMessage');
    if (message) {
      this.showLogoutMessage = true;
      localStorage.removeItem('logoutMessage');
    }
  },

  methods: {
    handleSignInGoogle() {
      const providerGoogle = new GoogleAuthProvider();
      this.signInWithProvider(providerGoogle);
    },

    signInWithProvider(provider) {
      this.isLoading = true;
      const auth = getAuth();

      signInWithPopup(auth, provider)
          .then((result) => {
            localStorage.setItem('user_email', result.user.email);
            localStorage.setItem('user_displayName', result.user.displayName);
            localStorage.setItem('user_uid', result.user.uid);

            this.user = result.user;
            this.isSignedIn = true;
            this.userUid = result.user.uid;

            this.saveUserDataToServer(result.user);
          })
          .catch((error) => {
            console.log(error);
            this.isLoading = false;
          });
    },

    saveUserDataToServer(user) {
      const userData = {
        email: user.email,
        displayName: user.displayName,
        uid: user.uid
      };

      axios.post(`${baseURL}/api/users`, userData)
          .then(response => {
            if (response.data.user_id) {
              localStorage.setItem('user_id', response.data.user_id);
              localStorage.setItem('is_admin', response.data.is_admin);
              localStorage.setItem('jwt_token', response.data.token);
              localStorage.setItem('jwt_exp', response.data.exp);

              this.isAdmin = response.data.is_admin;
              window.location.href = "/nastenka";
            }
          })
          .catch(error => {
            console.error('Error:', error);
          })
          .finally(() => {
            this.isLoading = false;
          });
    }
  }
};
</script>
